const extractFileName = (path = '') => {
    if (typeof path !== 'string') {
        return ''
    }

    const segments = path.split('/')

    return segments.pop() || ''
}

export const normalizeAttachment = attachment => {
    if (!attachment) {
        return null
    }

    if (typeof attachment === 'string') {
        return {
            id: null,
            file: attachment,
            name: extractFileName(attachment)
        }
    }

    const fileField = attachment.file
    const normalizedName = attachment.name ||
        (typeof fileField === 'string' ? extractFileName(fileField) : '')

    return {
        ...attachment,
        name: normalizedName
    }
}

export default {
    normalizeAttachment
}
